import { render, staticRenderFns } from "./ConsentFormView.vue?vue&type=template&id=5856d87d&"
import script from "./ConsentFormView.vue?vue&type=script&lang=js&"
export * from "./ConsentFormView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports